<template>
  <nuttrema-layout-form-standard
     theme="global"
     class="is-payment-form is-section-transparent"
    :edit="true">
    <template slot="center">

      <template v-if="_get(InstanceRegistrationPreCompletion, 'error')">
        <el-row type="flex" style="align-self: stretch">
          <el-col :span="24">
            <nuttrema-form-alert :error="_get(InstanceRegistrationPreCompletion, 'error')" style="margin: 2em 0"></nuttrema-form-alert>
          </el-col>
        </el-row>
      </template>

      <template v-else>
        <el-form
           label-width="30%"
          :ref="formRef"
          :rules="rules"
          :model="formData">

          <nuttrema-form-alert :error="_get(InstanceRegistrationCompletion, 'error')" style="margin: 2em 0"></nuttrema-form-alert>

          <section>
            <div class="section-items">

              <el-form-item
                 prop="instance_url"
                 class="el-form-item--w-50"
                :label="$t('label.instance_url')">
                <el-input
                   :disabled="true"
                   :value="$t('label.subdomain_example_url', { subdomain: options.subdomain })">
                   <template slot="prepend">http://</template>
                </el-input>
              </el-form-item>

              <el-form-item
                prop="instance_name"
                class="el-form-item--w-50"
                :label="$t('label.instance_name')">
                <el-input
                   v-model="formData.instance_name">
                </el-input>
              </el-form-item>

              <el-form-item
                 prop="first_name"
                 class="el-form-item--w-30"
                :label="$t('label.first_name')">
                <el-input v-model="formData.first_name"></el-input>
              </el-form-item>

              <el-form-item
                 prop="last_name"
                 class="el-form-item--w-50"
                :label="$t('label.last_name')">
                <el-input v-model="formData.last_name"></el-input>
              </el-form-item>

              <el-form-item :label="$t('label.date_of_birth')" prop="date_of_birth" class="el-form-item--w-30">
                <el-date-picker type="date" class="w-100" :placeholder="$t('label.pick_a_date')" v-model="formData.date_of_birth" format="dd/MM/yyyy" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('label.gender')" prop="gender" class="el-form-item--w-30">
                <el-select v-model="formData.gender" class="w-100" :placeholder="$t('label.select_gender')">
                  <el-option :label="$t('label.male')" value="male"></el-option>
                  <el-option :label="$t('label.female')" value="female"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('label.password')" prop="password" class="el-form-item--w-50 is-unset-line-height">
                <nuttrema-password-input v-model="formData.password"></nuttrema-password-input>
              </el-form-item>

              <el-form-item :label="$t('label.confirm_password')" prop="confirm_password" class="el-form-item--w-50 is-unset-line-height">
                <nuttrema-password-input v-model="formData.confirm_password"></nuttrema-password-input>
              </el-form-item>

              <el-form-item style="margin-top: 3em" class="el-form-item--w-50">
                <el-button
                   type="nuttrema-orange"
                   class="w-100"
                  :loading="InstanceRegistrationCompletion.saving"
                  @click="submitForm">
                  {{ $t('label.finish_registration') }}
                </el-button>
              </el-form-item>

            </div>
          </section>

        </el-form>
      </template>
      <!-- end else -->

    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { get, merge, pick } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';
import NuttremaNotification from 'components/ui/alert/nuttrema-notification';
import NuttremaPasswordInput from 'components/ui/input/nuttrema-password-input';

export default {
  name: 'cmpt-registration-completion',
  mixins: [FormStandardBehavior],
  componentName: 'CmptRegistrationCompletion',
  components: {
    NuttremaFormAlert,
    NuttremaNotification,
    NuttremaPasswordInput,
    NuttremaLayoutFormStandard,
  },
  props: {
    token: {
      required: false,
      default: null,
    },
    InstanceRegistrationCompletion: {
      required: false,
      default: null,
    },
    InstanceRegistrationPreCompletion: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      options: {
        subdomain: null,
      },
      formData: {
        token: null,
        instance_name: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        gender: null,
        password: null,
        confirm_password: null,
      },
      rules: {
        instance_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.instance_name', true),
            trigger: 'blur',
          },
        ],
        first_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.first_name', true),
            trigger: 'blur',
          },
        ],
        last_name: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.last_name', true),
            trigger: 'blur',
          },
        ],
        date_of_birth: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.date_of_birth', true),
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            trigger: 'change',
            message: this.formatValidationMessage('validation.required', 'label.gender', true),
          },
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
        ],
        confirm_password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.confirm_password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
          {
            trigger: 'blur',
            validator: this.validatePassword,
            message: this.formatValidationMessage('validation.confirm_password_not_match'),
          },
        ],
      },
    };
  },
  methods: {
    validatePassword(rule, value, callback) {
      if (value !== this.formData.password) callback(new Error());
      else callback();
    },
    getFormData() {
      return this.formData;
    },
    setFormData() {
      const data = get(this.InstanceRegistrationPreCompletion, 'data', {});
      this.options.subdomain = get(data, 'Instance.subdomain');

      merge(
        this.formData,
        pick(data, ['first_name', 'last_name', 'date_of_birth', 'gender']),
        { token: this.token },
      );

      // init form standard behaviour
      this.stateData = this.formData;
      this.formRef = 'form-registration-completion';
    },
  },
  created() {
    this.setFormData();
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/public/create-instance-thank-you/cmpt-registration-completion.vue